<template>
  <div>
    <div v-if="buyOrder">
      <section class="content">
        <div class="row" v-if="buyOrder">
            <div class="col-md-12">
              <div style="margin-bottom:5px">
                <el-badge :value="getBuyOrderStatusName(buyOrder.statusId)" type="info" >
                  <span style="text-align:left; position: relative" v-if="buyOrder.nic" :style="[buyOrder.history ? {'color': '#4370b7', 'cursor': 'pointer'} : {}]">
                    <font size="6" >OC: {{buyOrder.nic}}</font>
                  </span>
                </el-badge>
                <!-- <el-tag effect="plain" type="info"  round>{{  getBuyOrderStatusName(buyOrder.statusId) }}</el-tag> -->

                  <!-- <el-badge :value="{{ getBuyOrderStatusName(buyOrder.statusId) }}" class="item">
                    <el-button disabled type="warning" size="mini" style="cursor:default" icon="el-icon-bell" circle></el-button>
                  </el-badge> -->

                  <el-button @click="$router.go(-1)" style="display: inline-block; float: right; transition: all 1s;">
                    <i class="fas fa-angle-left"></i>
                    Volver
                  </el-button>
                <div style="text-align:right;position: relative">
                  <!-- <div class="btn-group">
                      <button type="button" class="btn btn-primary active statusBtn" style="outline: none; border:none;">{{ getBuyOrderStatusName(buyOrder.statusId) }}</button>
                    </div> -->
                  </div> 
                </div>
                <div class="box box-info">
                  <div class="box-body">

                    <!-- calendar group -->
                    
                    <table class="table table-striped" style="font-size:16px" >
                      <tbody>
                        <tr>
                          <th>Razón Social</th>
                          <td>{{buyOrder.company}}</td>
                        </tr>
                        <tr>
                          <th>Fecha de Liberación</th>
                          <td>{{buyOrder.fecha_liberacion}}</td>
                        </tr>
                        <tr>
                          <th>OC (PDF)</th>
                          <td v-if="buyOrder.pdf">
                            <a :href="buyOrder.pdf" target="_blank"><i class="	fa fa-file-pdf-o"/>  Ver</a>
                          </td>
                          <td v-if="!user.isProvider && !buyOrder.pdf">
                            <input type="file" accept="application/pdf" ref="fileBuyOrder" class="form-control-file" style="width:80%; float: left;" v-on:change="handleFileChange">
                            <el-button v-if="showUpload" @click="uploadBuyOrder" type="primary" style="margin-left:6%;" circle icon="el-icon-upload">
                            </el-button>
                          </td>
                        </tr>
                        <tr v-if="!user.isProvider && buyOrder.statusId === '2' || buyOrder.statusId === '9' || buyOrder.statusId === '3'">
                          <th>Cargar código de Operación</th>
                          <td>
                            <upload-order :idBuyOrder="buyOrder.idBuyOrder"/>
                          </td>
                        </tr>

                        <tr v-if="!user.isProvider && buyOrder.statusId === '1'">
                          <th></th>
                          <td>
                            <el-button type="primary" @click="activarBuyOrder()">Activar <i class="el-icon-check"/></el-button>
                            <el-button type="danger" @click="rechazarBuyOrder()">Rechazar <i class="el-icon-close"/></el-button>
                          </td>
                        </tr>
                        <tr v-if="buyOrder.hes.length > 0">
                          <th>HES Asociada</th>
                          <td>
                            <ul v-for="value in buyOrder.hes" :key="value.idHes">
                              <template v-if="value.number !== '0' && value.type === 'HES'">
                                {{ value.number }} -
                                {{ value.description }}
                              </template>
                              <template v-else>
                                
                              </template>
                            </ul>
                          </td>
                        </tr>
                        <tr v-if="buyOrder.hes.length > 0">
                          <th>MIGO Asociada</th>
                          <td>
                            <ul v-for="value in buyOrder.hes" :key="value.idMigo">
                              <template v-if="value.number !== '0' && value.type === 'MIGO'">
                                {{ value.number }} -
                                {{ value.description }}
                                <!-- - Cantidad:  {{ value.quantity }} -->
                              </template>
                              <template v-else>
                              </template>

                            </ul>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>


                <!--<el-dialog :visible.sync="centerDialogVisible" title="Finalizar Carga de documentos" width="30%" center>
                    <span style="margin-left: 50px;">
                      Esta seguro que desea finalizar la carga de documentos?
                    </span>
                    <template #footer>
                      <span class="dialog-footer">
                        <el-button v-on:click="centerDialogVisible = false">Cancelar</el-button>
                        <el-button type="primary" v-on:click="finishDocumentUploading">
                        Aceptar
                        </el-button>
                      </span>
                    </template>
                  </el-dialog>-->

                <div  v-if="buyOrder.documents && buyOrder.statusId >= '3'">
                  <h2> Documentos (Facturas, NC, ND) </h2>
                  <el-row>
                    <el-col  :xs="8" :sm="6" :md="4"  style="margin-right: 15px;margin: 10px;">
                      <upload-receipt :idCompany="buyOrder.idCompany" :idBuyOrder="buyOrder.idBuyOrder" :loadOperationType="false"/>
                    </el-col>
                    <!--<el-col v-if="!user.isProvider" :xs="8" :sm="6" :md="4" :lg="3" :xl="2" style="margin-bottom: 10px;">
                      <el-button v-on:click="centerDialogVisible = true" type="info">Finalizar Carga de Documentos</el-button>
                    </el-col>-->
                  </el-row>
                  <el-row style="margin-bottom: 20px;">
                    <el-col :span="6">
                      <el-select clearable placeholder="Tipo de documento" multiple v-model="filters[0].value">
                        <el-option  v-for="item in buyOrderDocumentType" :value="item.idBuyOrderDocumentType" :key="item.buyOrderDocumentType" :label="item.description"></el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="6">
                      <el-select clearable placeholder="Estado" multiple v-model="filters[1].value">
                        <el-option  v-for="item in buyOrderDocumentStatus" :key="item.idBuyOrderDocumentStatus" :value="item.idBuyOrderDocumentStatus" :label="item.description"></el-option>
                      </el-select>
                    </el-col>
                  </el-row>


                  <data-tables :data="buyOrder.documents" :filters="filters" :pagination-props="{ pageSizes: [5, 10, 15] }">
                    <el-table-column label="Tipo">
                      <template slot-scope="scope">
                        {{ getTypeName(scope.row.documentType) }}
                      </template>
                    </el-table-column>
                    <el-table-column v-for="title in titleDocument" :prop="title.prop" :label="title.label" :key="title.prop" sortable="custom">
                    </el-table-column>
                    <!--<el-table-column label="Info. Rechazo ">
                      <template slot-scope="scope">
                        <el-button icon="el-icon-info" type="primary" circle @click="mostrarMensajeCompleto(scope.row.mensajeRechazo)"></el-button>
                      </template>
                    </el-table-column>-->

                    <el-table-column label="Estado">
                      <template slot-scope="scope">
                        {{ getStatusName(scope.row.idBuyOrderDocumentStatus) }}
                      </template>
                    </el-table-column>
                    <el-table-column label="Código">
                      <template slot-scope="scope">
                        {{ scope.row.number }}
                      </template>
                    </el-table-column>
                    <el-table-column label="Tipo de código">
                      <template slot-scope="scope">
                        {{ scope.row.type }}
                      </template>
                    </el-table-column>
                    <el-table-column label="Archivo">
                      <template slot-scope="scope">
                        <a v-if="scope.row.pdf !== '0'" :href="'upload/' + scope.row.pdf" target="_blank" style="padding-right: 20px">
                          <i class="fa fa-file-pdf-o"/> PDF
                        </a>
                      </template>
                    </el-table-column>
                    <!--<el-table-column>
                      <template slot-scope="scope" >
                        <el-tooltip class="item" effect="dark" v-if="(!user.isProvider && scope.row.idBuyOrderDocumentStatus === '2') || scope.row.idBuyOrderDocumentStatus === '4'" content="Orden de Pago" placement="top"> 
                          <el-button :type="scope.row.idBuyOrderDocumentStatus === '2' ? 'primary' : 'success'" icon="far fa-file-alt" circle @click="openModalPaymentOrder(scope.row)"></el-button>
                        </el-tooltip>
                      </template>
                    </el-table-column>-->
                    <!--<el-table-column label="Guardar" fixed="right" align="center" v-if="!user.isProvider">
                      <template slot="header" slot-scope="scope">
                      </template>
                      <template slot-scope="scope" v-if="scope.row.idBuyOrderDocumentStatus === '1'">
                        <el-button-group>
                          <el-tooltip class="item" effect="dark" content="Aprobar" placement="bottom-end">

                          <el-button icon="el-icon-success" size="mini" :type="(documentosAceptados.includes(scope.row)) ? 'success' : ''" @click="handleIncluirDocumento(scope.row, 2)">
                          </el-button>
                          </el-tooltip>
                          <el-tooltip class="item" effect="dark" content="Rechazar" placement="bottom-end">
                          <el-button icon="el-icon-error"  size="mini" :type="(documentosRechazados.includes(scope.row)) ? 'danger' : ''" @click="handleIncluirDocumento(scope.row, 3)">
                          </el-button>
                          </el-tooltip>
                        </el-button-group>
                      </template>
                    </el-table-column>-->
                  </data-tables>
                </div>


                <!-- MODAL CONFIRMAR DOCUMENTACION -->

                <el-dialog title="Confirmar cambios" style="margin-top: -10vh; overflow: hidden" :visible.sync="showModalConfirmarDocumentacion" max-width="700px" width="80%" v-on:close="cerrarModalConfirmarDocumentacion()">
                  <el-tabs type="card">
                    <el-tab-pane :label="'Documentos aceptados (' + documentosAceptados.length + ')'">
                      <el-table :data="documentosAceptados">
                        <el-table-column label="Tipo">
                          <template slot-scope="scope">
                            {{ getTypeName(scope.row.documentType) }}
                          </template>
                        </el-table-column>
                        <el-table-column property="date" label="Fecha"></el-table-column>
                        <el-table-column label="Archivo">
                          <template slot-scope="scope">
                            <a :href="scope.row.pdf" target="_blank" style="padding-right: 20px">
                              <i class="fa fa-file-pdf-o"/> PDF
                            </a>
                          </template>
                        </el-table-column>
                      </el-table>
                    </el-tab-pane>
                    <el-tab-pane :label="'Documentos rechazados (' + documentosRechazados.length + ')'">
                      <el-table :data="documentosRechazados">
                        <el-table-column label="Tipo" width="130px">
                          <template slot-scope="scope">
                            {{ getTypeName(scope.row.documentType) }}
                          </template>
                        </el-table-column>
                        <el-table-column property="date" label="Fecha" width="200px"></el-table-column>
                        <el-table-column label="Archivo" width="90px">
                          <template slot-scope="scope">
                            <a :href="scope.row.pdf" target="_blank" style="padding-right: 20px">
                              <i class="fa fa-file-pdf-o"/> PDF
                            </a>
                          </template>
                        </el-table-column>
                        <el-table-column label="Mensaje" :span="12">
                          <template slot-scope="scope">
                            <el-select v-model="scope.row.mensajeRechazo" placeholder="Seleccione un motivo">
                              <el-option
                                v-for="reason in rejectReasons"
                                :key="reason.value"
                                :label="reason.value"
                                :value="reason.value">
                              </el-option>
                            </el-select>
                          </template>
                        </el-table-column>
                      </el-table>
                    </el-tab-pane>
                  </el-tabs>

                  <span slot="footer" class="dialog-footer">
                    <button class="btn" v-on:click="cerrarModalConfirmarDocumentacion()">
                      Cancelar
                    </button>
                    <button class="btn btn-primary" v-on:click="confirmarDocumentos()">
                      Guardar
                    </button>
                  </span>
                </el-dialog>

                <!-- MODAL AGREGAR DOCUMENTACION -->

                <el-dialog title="Precarga de Documento (Factura / ND / NC)" :visible.sync="showModalCreateDocument" width="90%" :lock-scroll="false" v-on:close="resetNuevoDocumento()" max-width="500px">
          
              <el-form label-width="150px" label-position="left"	>

              <el-form-item label= "Fecha Vencimiento"    prop="linea">
                             <el-date-picker
                                v-validate="'required'"
                                format="dd/MM/yyyy"
                                value-format="yyyy-MM-dd"
                                v-model="nuevoDocumento.FechaVencimiento"
                                type="date"
                                placeholder="Fecha Vencimiento">
                              </el-date-picker>                      
            </el-form-item>
            
            <el-form-item label= "Tipo" prop="linea">
                            <el-select clearable placeholder="Tipo de documento" required v-model="nuevoDocumento.documentType">
                        <el-option  v-for="item in buyOrderDocumentType" :disabled="(!(item.idBuyOrderDocumentType === '1' || tieneFacturaAceptada())) && buyOrder.nic !== null" :key="item.idBuyOrderDocumentType" :value="item.idBuyOrderDocumentType" :label="item.description"></el-option>
                      </el-select>  
                        <el-select clearable placeholder="Código AFIP" required v-model="nuevoDocumento.documentTypeCode">
                         <el-option  v-for="item in buyOrderDocumentTypeCode" :key="item.idBuyOrderDocumentTypeCode" :value="item.idBuyOrderDocumentTypeCode" :label="item.description"></el-option>
                        </el-select> 
            </el-form-item>

            <el-form-item label= "Tipo" prop="Nª" >
            
                 <el-select style="width: 100px"   v-validate="'required'" required name="letra" placeholder="Letra" filterable clearable v-model="nuevoDocumento.letra">
                              <el-option label="A" value="A"></el-option>
                              <el-option label="B" value="B"></el-option>
                              <el-option label="C" value="C"></el-option>
                </el-select>
                <el-input style="width: 200px"  type="text" v-validate="'required'" required name="puntoVenta" placeholder="Punto de Venta" v-model="nuevoDocumento.puntoVenta"></el-input>
                <el-input type="text" v-validate="'required'" required name="numero" style="width: 500px" placeholder="Numero" v-model="nuevoDocumento.numero"></el-input>
          
            </el-form-item>  

            <el-form-item label= "Moneda">
                 <el-select style="width: 200px"   v-validate="'required'" required name="letra" placeholder=" Moneda" filterable clearable v-model="nuevoDocumento.moneda">
                              <el-option label="$" value="$"></el-option>
                              <el-option label="U$A" value="U$A"></el-option>
                 </el-select>
                <el-input style="width: 200px" type="text" v-validate="'required'" required name="nombre" placeholder="Tipo de Cambio" v-model="nuevoDocumento.tipoCambio"></el-input>
            </el-form-item>  


             <template v-if="buyOrder.hes.length > 0">
                    <el-form-item label= "Asociar HES">
                      <el-select v-model="nuevoDocumento.hes" multiple placeholder="Seleccionar HES">
                        <el-option
                          v-for="item in buyOrder.hes"
                          :key="item.idHes"
                          :label="item.number + '-' + item.description "
                          :value="item.idHes">
                        </el-option>
                      </el-select>
                    </el-form-item>
            </template>
             <template v-if="buyOrder.hes.length > 0">
               <el-form-item label= "Asociar MIGO"> 
                      <el-select v-model="nuevoDocumento.migo" multiple placeholder="Seleccionar Migo">
                        <el-option
                          v-for="item in buyOrder.migo"
                          :key="item.idMigo"
                          :label="item.number + '-' + item.description + '- Cantidad: ' + item.quantity"
                          :value="item.idMigo">
                        </el-option>
                      </el-select>
                     </el-form-item>    
                  </template>
               <el-form-item label= "PDF"> 
                  <input type="file" accept="application/pdf" ref="fileDocument" class="form-control-file" style="width:80%; float: left;" v-on:change="handleFileChange">
               </el-form-item>
           </el-form>
           <el-divider>Linea</el-divider>
           <el-form>
            <el-form-item label-width="0" prop="linea">
                    <el-row align="center" type="flex" style="text-align: center;" justify="center" :gutter="10">
                      <el-col :span="2">
                        Código
                      </el-col>
                      <el-col :span="4">
                        Producto/Servicio
                      </el-col>
                       <el-col :span="2">
                        Cant.
                      </el-col>
                       <el-col :span="2">
                        U. Medida
                      </el-col>
                       <el-col :span="3">
                        Prec. Unitario
                      </el-col>
                      <el-col :span="2">
                        % Bon.
                      </el-col>
                      <el-col :span="3">
                        Importe Bon.
                      </el-col>
                       <el-col :span="2">
                        Subtotal
                      </el-col>
                      <el-col :span="3">
                        Alicuota IVA
                      </el-col>
                      <el-col :span="3">
                        Subtotal C/IVA
                      </el-col>
                      <el-col :span="1">
                      </el-col>
                    </el-row>
            </el-form-item>

            <el-row   v-for="(linea, lineaId) in nuevoDocumento.lineas" :key="lineaId" align="center" type="flex" style="text-align: center; margin-bottom:15px;" justify="center" :gutter="5">
                      <el-col :span="2">
                        <el-form-item :prop="'linea.' + linea + '.codigo'">
                         <el-input type="text" required name="Codigo" placeholder="Codigo" v-model="linea.codigo"></el-input>
                        </el-form-item>
                      </el-col>
                        <el-col :span="4">
                        <el-form-item :prop="'linea.' + linea + '.descripcion'">
                             <el-input type="text" required name="Descripcion" placeholder="Descripcion" v-model="linea.descripcion"></el-input>
                        </el-form-item>
                      </el-col>
                       <el-col :span="2">
                        <el-form-item :prop="'linea.' + linea + '.cantidad'">
                             <el-input type="text" required name="Cantidad" placeholder="Cantidad" v-model="linea.cantidad"></el-input>
                        </el-form-item>
                      </el-col>
                       <el-col :span="2">
                        <el-form-item :prop="'linea.' + linea + '.medida'">                       
                        <el-select style="width: 100px"   v-validate="'required'" required name="Medida" placeholder="Medida" filterable clearable  v-model="linea.medida">
                              <el-option label="Unidades" value="1"></el-option>
                              <el-option label="Kilogramos" value="2"></el-option>
                              <el-option label="Metros" value="3"></el-option>
                              <el-option label="Otro" value="4"></el-option>
                            </el-select>
                       
                        </el-form-item>
                      </el-col>
                       <el-col :span="3">
                        <el-form-item :prop="'linea.' + linea + '.precio'">
                             <el-input type="text" required name="precio" placeholder="precio" v-model="linea.precio"  @change="updateLinea(linea)"></el-input>
                        </el-form-item>
                      </el-col>
                       <el-col :span="2">
                        <el-form-item :prop="'linea.' + linea + '.porBoni'">
                             <el-input type="text" required name="porBoni" placeholder="% Bonif." v-model="linea.porBoni"  @change="updateLinea(linea)"></el-input>
                        </el-form-item>
                      </el-col>
                       <el-col :span="3">
                        <el-form-item :prop="'linea.' + linea + '.importeBoni'">
                                 {{'$' + linea.importeBoni}}
                        </el-form-item>
                      </el-col>
                       <el-col :span="2">
                        <el-form-item :prop="'linea.' + linea + '.subtotal'">
                          {{'$' + linea.subtotal}}
                            
                        </el-form-item>
                      </el-col>
                       <el-col :span="3">
                        <el-form-item :prop="'linea.' + linea + '.iva'">                       
                        <el-select style="width: 100px"   v-validate="'required'" required name="Iva" placeholder="Iva" filterable clearable  v-model="linea.iva" @change="updateLinea(linea)">
                              <el-option label="Exento" value="1"></el-option>
                             <el-option label="2,5%" value="1.025"></el-option>
                              <el-option label="0,5%" value="1.05"></el-option>
                              <el-option label="21%" value="1.21"></el-option>
                              <el-option label="27%" value="1.27"></el-option>
                            </el-select>
                        </el-form-item>
                      </el-col>
                     <el-col :span="3">
                        <el-form-item :prop="'linea.' + linea + '.subtotalIva'">                       
                       {{'$' + linea.subtotalIva}}
                        </el-form-item>
                      </el-col>
                      <el-col :span="1">
                      <el-button type="warning" size="small" v-on:click="deleteLinea(linea)">X</el-button>  
                      </el-col>
                  </el-row>  
                   <div class="text-center">
                    <el-button type="primary" size="small" v-on:click="addLinea()" justify="center" >Agregar linea</el-button>
                  </div>
                  <br>
                      <el-divider>Otros Impuestos</el-divider>

           <el-form-item label-width="0" prop="impuesto">
                    <el-row align="center" type="flex" style="text-align: center;" justify="center" :gutter="10">
                      <el-col :span="4">
                        Descripción
                      </el-col>
                      <el-col :span="4">
                        Detalle
                      </el-col>
                       <el-col :span="3">
                        Base Imponible
                      </el-col>
                       <el-col :span="3">
                        Alicuota %
                      </el-col>
                       <el-col :span="3">
                        Importe
                      </el-col>
                      <el-col :span="3">
                      </el-col>
                      <el-col :span="1">
                      </el-col>
                       <el-col :span="1">        
                      </el-col>
                      <el-col :span="2">
                      </el-col>
                      <el-col :span="2">
                      </el-col>
                      <el-col :span="1">
                      </el-col>
                    </el-row>
                    <el-row   v-for="(impuesto, impuestoId) in nuevoDocumento.impuestos" :key="impuestoId" align="center" type="flex" style="text-align: center; margin-bottom:15px;" justify="center" :gutter="5">
                      <el-col :span="4">
                        <el-form-item :prop="'impuesto.' + impuesto + '.descripcion'">
                         <el-input type="text" required name="Descripcion" placeholder="Descripcion" v-model="impuesto.descripcion"></el-input>
                        </el-form-item>
                      </el-col>
                    <el-col :span="4">
                        <el-form-item :prop="'impuesto.' + impuesto + '.detalle'">
                         <el-input type="text" required name="Detalle" placeholder="Detalle" v-model="impuesto.detalle"></el-input>
                        </el-form-item>
                      </el-col>
                    <el-col :span="3">
                        <el-form-item :prop="'impuesto.' + impuesto + '.baseImponible'">
                         <el-input type="text" required name="baseImponible" placeholder="Base Imponible" v-model="impuesto.baseImponible" @change="updateImpuesto(impuesto)"></el-input>
                        </el-form-item>
                      </el-col>
                         <el-col :span="3">
                        <el-form-item :prop="'impuesto.' + impuesto + '.alicuota'">
                         <el-input type="text" required name="alicuota" placeholder="Alicuota" v-model="impuesto.alicuota"  @change="updateImpuesto(impuesto)"></el-input>
                        </el-form-item>
                      </el-col>
                        <el-col :span="3">
                        <el-form-item :prop="'impuesto.' + impuesto + '.importe'">
                         {{'$' + impuesto.importe}}
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                      </el-col>
                      <el-col :span="1">
                      </el-col>
                       <el-col :span="1">
                        
                      </el-col>
                      <el-col :span="2">
                      </el-col>
                      <el-col :span="2">
                      </el-col>
                      <el-col :span="1">
                      <el-button type="warning" size="small" v-on:click="deleteImpuesto(impuesto)">X</el-button>  
                      </el-col>
                    </el-row>

                    <div class="text-center">
                    <el-button type="primary" size="small" v-on:click="addImpuesto()" justify="center" >Agregar Impuesto</el-button>
                  </div>
            </el-form-item>
            
      <el-form-item label-width="0" prop="linea">
                    <el-row align="center" type="flex" style="text-align: center;" justify="center" :gutter="10">
                      <el-col :span="2">
                      </el-col>
                      <el-col :span="4">
                      </el-col>
                       <el-col :span="2">
                      </el-col>
                       <el-col :span="2">
                      </el-col>
                       <el-col :span="3">
                      </el-col>
                      <el-col :span="2">
                      </el-col>
                      <el-col :span="3">
                      </el-col>
                       <el-col :span="2"> 
                      </el-col>
                      <el-col :span="3">
                      </el-col>
                      <el-col :span="3">
                      </el-col>
                      <el-col :span="1">
                      </el-col>
                    </el-row>
                  <el-row align="center" type="flex" style="text-align: center;" justify="center" :gutter="10">
                      <el-col :span="2">
                      </el-col>
                      <el-col :span="4">
                      </el-col>
                       <el-col :span="2">
                      </el-col>
                       <el-col :span="2">
                      </el-col>
                       <el-col :span="3">
                      </el-col>
                      <el-col :span="2">
                      </el-col>
                      <el-col :span="3">
                      </el-col>
                       <el-col :span="2"> 
                      </el-col>
                      <el-col :span="3">
                        Total sin Impuesto
                      </el-col>
                      <el-col :span="3">
                        {{'$' + this.nuevoDocumento.importeTotal}}
                      </el-col>
                      <el-col :span="1">
                      </el-col>
                    </el-row>
                    <el-row align="center" type="flex" style="text-align: center;" justify="center" :gutter="10">
                      <el-col :span="2">
                      </el-col>
                      <el-col :span="4">
                      </el-col>
                       <el-col :span="2">
                      </el-col>
                       <el-col :span="2">
                      </el-col>
                       <el-col :span="3">
                      </el-col>
                      <el-col :span="2">
                      </el-col>
                      <el-col :span="3">
                      </el-col>
                       <el-col :span="2"> 
                      </el-col>
                      <el-col :span="3">
                        Total con IVA
                      </el-col>
                      <el-col :span="3">
                        {{'$' + this.nuevoDocumento.importeImpuesto}}
                      </el-col>
                      <el-col :span="1">
                      </el-col>
                    </el-row>
                    <el-row align="center" type="flex" style="text-align: center;" justify="center" :gutter="10">
                      <el-col :span="2">
                      </el-col>
                      <el-col :span="4">
                      </el-col>
                       <el-col :span="2">
                      </el-col>
                       <el-col :span="2">
                      </el-col>
                       <el-col :span="3">
                      </el-col>
                      <el-col :span="2">
                      </el-col>
                      <el-col :span="3">
                      </el-col>
                       <el-col :span="1"> 
                      </el-col>
                      <el-col :span="4">
                        Total Otros Impuestos
                      </el-col>
                      <el-col :span="3">
                        {{ '$' + this.nuevoDocumento.importeOtrosImpuesto}}
                      </el-col>
                      <el-col :span="1">
                      </el-col>
                    </el-row>                    <el-row align="center" type="flex" style="text-align: center;" justify="center" :gutter="10">
                      <el-col :span="2">
                      </el-col>
                      <el-col :span="4">
                      </el-col>
                       <el-col :span="2">
                      </el-col>
                       <el-col :span="2">
                      </el-col>
                       <el-col :span="3">
                      </el-col>
                      <el-col :span="2">
                      </el-col>
                      <el-col :span="3">
                      </el-col>
                       <el-col :span="2"> 
                      </el-col>
                      <el-col :span="3">
                        Total con IVA
                      </el-col>
                      <el-col :span="3">
                        {{'$' + this.nuevoDocumento.importeImpuesto}}
                      </el-col>
                      <el-col :span="1">
                      </el-col>
                    </el-row>
                    <el-row align="center" type="flex" style="text-align: center;" justify="center" :gutter="10">
                      <el-col :span="2">
                      </el-col>
                      <el-col :span="4">
                      </el-col>
                       <el-col :span="2">
                      </el-col>
                       <el-col :span="2">
                      </el-col>
                       <el-col :span="3">
                      </el-col>
                      <el-col :span="2">
                      </el-col>
                      <el-col :span="3">
                      </el-col>
                       <el-col :span="1"> 
                      </el-col>
                      <el-col :span="4">
                        Total con Impuestos
                      </el-col>
                      <el-col :span="3">
                        {{'$' + this.nuevoDocumento.importeTotalImpuesto}}
                      </el-col>
                      <el-col :span="1">
                      </el-col>
                    </el-row>
            </el-form-item>
           </el-form>
                     
                  <span slot="footer" class="dialog-footer">
                    <button class="btn" v-on:click="hideModal()">
                      Cancelar
                    </button>
                    <button class="btn btn-primary" v-on:click="createDocument()">
                      Enviar
                    </button>
                  </span>
                </el-dialog>

                <!-- MODAL AGREGAR ORDEN DE PAGO -->

                <el-dialog :title="'Orden de pago'" style="margin-top: -10vh; overflow: hidden"  v-if="buyOrderDocument" :visible.sync="showModalPaymentOrder" width="70%" :lock-scroll="false" v-on:close="resetNewPaymentOrder()" max-width="500px">
                  <div class="col-sm-12 entrada">
                    <div class="col-sm-4">
                      <label style="margin-top: -10px;">Orden de Pago / Retenciones</label>
                    </div>
                    <div class="col-sm-8">
                      <td v-if="buyOrderDocument.paymentOrder && buyOrderDocument.paymentOrder.pdf">
                        <a v-if="buyOrderDocument.paymentOrder.pdf !== '0'" :href="buyOrderDocument.paymentOrder.pdf" target="_blank"><i class="	fa fa-file-pdf-o"/>  Ver</a>
                        <span v-else>No se cargo un archivo</span>
                      </td>
                      <span v-if="!user.isProvider && (!buyOrderDocument.paymentOrder || !buyOrderDocument.paymentOrder.pdf)">
                        <input type="file" accept="application/pdf" ref="filePayment" class="form-control-file" style="width:80%; float: left;" v-on:change="handleFileChange">
                      </span>
                    </div>
                  </div>
                  <br><br><br>
                  <div class="col-sm-12 entrada">
                    <div class="col-sm-4">
                      <label style="margin-top: -10px;">Información de Pago</label>
                    </div>
                    <div class="col-sm-8">
                      <td>
                        <span v-if="buyOrderDocument.idBuyOrderDocumentStatus === '4' && buyOrderDocument.paymentOrder" v-html="buyOrderDocument.paymentOrder.comment"></span>
                      </td>
                      <span v-if="buyOrderDocument.idBuyOrderDocumentStatus === '2' && !user.isProvider && !buyOrderDocument.paymentOrder">
                        <vue-editor v-model="newPaymentOrder.comment"></vue-editor>
                      </span>
                    </div>
                  </div>

                  
                  <span slot="footer" class="dialog-footer">
                    <button v-if="!buyOrderDocument.paymentOrder" class="btn" v-on:click="hideModalPaymentOrder()">
                      Cancelar
                    </button>
                    <button v-if="!buyOrderDocument.paymentOrder" class="btn btn-primary" v-on:click="uploadPayment()">
                      Guardar
                    </button>
                    <button  v-if="buyOrderDocument.paymentOrder" class="btn btn-primary" v-on:click="hideModalPaymentOrder()">
                      Aceptar
                    </button>
                  </span>
                </el-dialog>
              </div>

        </div>
        <h2 v-if="buyOrder.historial && !user.isProvider"> Historial </h2>
        <data-tables v-if="buyOrder.historial && !user.isProvider" :data="buyOrder.historial" :pagination-props="{ pageSizes: [5, 10, 15] }">

          <el-table-column v-for="title in [{'prop': 'detalle', 'label': 'Detalle'}, {'prop' : 'date', label: 'Fecha'}]" :prop="title.prop" :label="title.label" :key="title.prop"  :default-sort = "{prop: 'date', order: 'ascending'}"
           sortable="custom">
          </el-table-column>
        </data-tables>
      </section>
    </div>
  </div>
</template>
<script>
  require('moment')
  import datepicker from 'vue-date-picker'
  import api from '../../api'
  import { mapState } from 'vuex'
  import { VueEditor } from 'vue2-editor'
  import UploadOrder from './UploadOrder.vue'
  import UploadReceipt from './UploadReceipt.vue'

  export default {
    name: 'Settings',
    components: {
      datepicker,
      VueEditor,
      'upload-receipt': UploadReceipt,
      'upload-order': UploadOrder
    },
    data (router) {
      return {
        buyOrder: '',
        centerDialogVisible: false,
        section: 'Search',
        loading: false,
        idUser: this.$store.state.user.idUser,
        idBuyOrder: this.$route.query.i,
        showModalCreateDocument: false,
        showModalConfirmarDocumentacion: false,
        showModalPaymentOrder: false,
        buyOrderDocument: '',
        newPaymentOrder: {
          pdf: '',
          comment: ''
        },
        documentoRechazado: [],
        nuevoDocumento: {
          idBuyOrder: '',
          pdf: '',
          letra: '',
          numero: '',
          lineas: [],
          impuestos: [],
          fechaVencimiento: null,
          documentType: '',
          importeTotal: 0,
          importeImpuesto: 0,
          importePorcentaje: '',
          moneda: '',
          importeOtrosImpuesto: 0,
          importeTotalImpuesto: 0,
          tipoCambio: '',
          visto: 0,
          idBuyOrderDocumentStatus: 1,
          mensajeRechazo: '',
          documentComment: ''
        },
        lineaData: {
          codigo: '',
          descripcion: '',
          cantidad: 0,
          medida: '',
          precio: 0,
          porBoni: 0,
          importeBoni: 0,
          subtotal: 0,
          iva: '',
          subtotalIva: 0
        },
        impuestoData: {
          detalle: '',
          descripcion: '',
          baseImponible: 0,
          alicuota: 0,
          importe: 0
        },
        showUpload: false,
        confirmPayment: false,
        documentosAceptados: [],
        documentosRechazados: [],
        nuevoMensajeRechazo: '',
        rejectReasons: [{
          value: 'Daño en las mercaderías, cuando no estuviesen expedidas o entregadas por su cuenta y riesgo.'
        }, {
          value: 'Vicios, defectos y diferencias en la calidad o en la cantidad debidamente comprobados.'
        }, {
          value: 'Divergencias en los plazos o en los precios estipulados.'
        }, {
          value: 'No Correspondencia con los servicios o la obra efectivamente contratados.'
        }, {
          value: 'Existencia de vicios formales que causen su inhabilidad tanto como titulo ejecutivo y valor no caratular, así como documento comercial.'
        }, {
          value: 'Falta de entrega de la mercadería o prestación del servicio.'
        }],
        filters: [{
          prop: 'documentType',
          value: []
        }, {
          prop: 'idBuyOrderDocumentStatus',
          value: []
        }],
        titleDocument: [{
          prop: 'date',
          label: 'Fecha de carga'
        }]
      }
    },
    computed: {
      ...mapState([
        'user',
        'lineas',
        'otherOperations'
      ]),
      statusList () {
        if (this.buyOrder.nic === null) {
          const lista = this.$store.state.countStatus.filter(el => el.statusId === '1' || el.statusId === '2' || el.statusId === '3' || el.statusId === '7')
          return lista
          // return this.$store.state.countStatus.filter(el => el.statusId === '4' || el.statusId === '5' || el.statusId === '8')
        }
        return this.$store.state.countStatus
      },
      buyOrderDocumentType () {
        return this.$store.state.buyOrderDocumentType
      },
      buyOrderDocumentTypeCode () {
        return this.$store.state.buyOrderDocumentTypeCode
      },
      buyOrderDocumentStatus () {
        return this.$store.state.buyOrderDocumentStatus
      },
      documentType () {
        return this.$store.state.documentType
      }
    },
    methods: {
      getBuyOrder () {
        api.request('GET', 'api/getBuyOrderByPk/' + this.$route.query.i)
        .then(response => {
          var data = response.data
          if (data.error) {
            return
          }
          if (data) {
            let orders = data
            this.buyOrder = orders[0]
          }
        })
      },
      finishDocumentUploading () {
        api.request('POST', 'api/finishDocumentUploading', JSON.stringify(this.idBuyOrder))
          .then(response => {
            this.$message.success('El estado de la orden de compra ha sido actualizado', 'success')
            this.hideModal()
            this.centerDialogVisible = false
          })
          .catch(error => {
            this.$message.error(error.response.data, 'error')
          })
      },
      addLinea () {
        this.nuevoDocumento.lineas.push(Object.assign({}, this.lineaData))
        this.calcularLineas()
      },
      addImpuesto () {
        this.nuevoDocumento.impuestos.push(Object.assign({}, this.impuestoData))
      },
      updateLinea (linea) {
        linea.importeBoni = (linea.precio * linea.cantidad) * (linea.porBoni / 100)
        linea.subtotal = (linea.precio * linea.cantidad) - linea.importeBoni
        linea.subtotalIva = linea.subtotal * linea.iva
        this.nuevoDocumento.importeTotal = this.nuevoDocumento.importeTotal + linea.subtotal
        this.calcularLineas()
      },
      calcularLineas () {
        this.nuevoDocumento.importeImpuesto = 0
        this.nuevoDocumento.importeTotal = 0
        this.nuevoDocumento.importeTotalImpuesto = 0
        for (var j = 0; j < this.nuevoDocumento.lineas.length; j++) {
          this.nuevoDocumento.importeTotal = this.nuevoDocumento.importeTotal + this.nuevoDocumento.lineas[j].subtotal
          this.nuevoDocumento.importeImpuesto = this.nuevoDocumento.importeImpuesto + this.nuevoDocumento.lineas[j].subtotalIva
        }
        this.nuevoDocumento.importeTotalImpuesto = this.nuevoDocumento.importeOtrosImpuesto + this.nuevoDocumento.importeImpuesto
      },
      calcularImpuestos () {
        this.nuevoDocumento.importeOtrosImpuesto = 0
        this.nuevoDocumento.importeTotalImpuesto = 0
        for (var j = 0; j < this.nuevoDocumento.impuestos.length; j++) {
          this.nuevoDocumento.importeOtrosImpuesto = this.nuevoDocumento.importeOtrosImpuesto + this.nuevoDocumento.impuestos[j].importe
        }
        this.nuevoDocumento.importeTotalImpuesto = this.nuevoDocumento.importeOtrosImpuesto + this.nuevoDocumento.importeImpuesto
      },
      updateImpuesto (impuesto) {
        console.log(impuesto)
        impuesto.importe = impuesto.baseImponible * (impuesto.alicuota / 100)
        this.calcularImpuestos()
      },
      deleteLinea (item) {
        var index = this.nuevoDocumento.lineas.indexOf(item)
        if (index !== -1) {
          this.nuevoDocumento.lineas.splice(index, 1)
        }
        this.calcular()
      },
      deleteImpuesto (item) {
        var index = this.nuevoDocumento.impuestos.indexOf(item)
        if (index !== -1) {
          this.nuevoDocumento.impuestos.splice(index, 1)
        }
        this.calcularImpuestos()
      },
      openModalPaymentOrder (buyOrderDocument) {
        this.showModalPaymentOrder = true
        this.buyOrderDocument = buyOrderDocument
      },
      hideModal () {
        this.resetNuevoDocumento()
        this.showModalCreateDocument = false
      },
      datetime () {
        let date = new Date()
        return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds()
      },
      handleFileChange () {
        this.showUpload = (this.$refs.fileBuyOrder && this.$refs.fileBuyOrder.files.length > 0) || (this.$refs.filePayment && this.$refs.filePayment.files.length > 0)
      },
      uploadBuyOrder () {
        this.$confirm('¿Realmente desea adjuntar este pdf a la OC?', 'Advertencia', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancelar',
          type: 'warning',
          lockScroll: false
        })
        .then(() => {
          let formData = new FormData()
          formData.append('file', this.$refs.fileBuyOrder.files[0])
          formData.append('folder', 'buyOrders')
          api.request('POST', 'api/uploadFile', formData)
          .then(response => {
            this.buyOrder.pdf = response.data
            api.request('POST', 'api/generic/buyOrder/' + this.buyOrder.idBuyOrder, JSON.stringify(this.buyOrder))
            .then(response2 => {
              api.request('POST', 'api/generic/buyOrderHistory', JSON.stringify({ 'idBuyOrder': this.buyOrder.idBuyOrder, 'detalle': this.$store.state.countStatus[2].description, 'date': this.datetime() }))
              .then(response3 => {
                this.getBuyOrder()
                this.hideModal()
              })
            })
          })
        })
        .catch(() => {
        })
      },
      uploadPayment () {
        if (this.newPaymentOrder.comment === null) {
          this.$alert('Para confirmar la operación debe detallar la información de Pago', 'Advertencia', {
            confirmButtonText: 'Aceptar',
            type: 'warning',
            lockScroll: false
          })
        } else {
          this.$confirm('¿Realmente desea adjuntar el comprobante?', 'Advertencia', {
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar',
            type: 'warning',
            lockScroll: false
          })
                .then(() => {
                  let formData = new FormData()
                  formData.append('file', this.$refs.filePayment.files[0])
                  formData.append('folder', 'payments')
                  api.request('POST', 'api/uploadFile', formData)
                        .then(response => {
                          api.request('POST', 'api/generic/paymentOrder', JSON.stringify({
                            'pdf': response.data,
                            'comment': this.newPaymentOrder.comment
                          }))
                          .then(response2 => {
                            this.buyOrderDocument.idBuyOrderDocumentStatus = '4'
                            this.buyOrderDocument.idPaymentOrder = response2.data.idPaymentOrder
                            api.request('POST', 'api/generic/buyOrderDocument/' + this.buyOrderDocument.idBuyOrderDocument, JSON.stringify(this.buyOrderDocument))
                            .then(response3 => {
                              api.request('GET', 'api/sendMailBuyOrderDocumentStatus/' + this.buyOrderDocument.idBuyOrderDocument)
                              this.hideModalPaymentOrder()
                              this.getBuyOrder()
                            })
                          })
                        })
                })
                .catch(() => {
                })
        }
      },
      tieneFacturaAceptada () {
        return this.buyOrder.documents && this.buyOrder.documents.find(el => el.documentType === '1' && (el.idBuyOrderDocumentStatus === '2' || el.idBuyOrderDocumentStatus === '4')) !== undefined
      },
      mostrarMensajeCompleto (mensaje) {
        this.$alert(mensaje, 'Mensaje', {
          confirmButtonText: 'OK'
        })
      },
      createDocument () {
        if (this.nuevoDocumento.documentType === '') {
          this.$message({
            type: 'warning',
            message: 'Elija el tipo de documento'
          })
          return
        }
        if (this.$refs.fileDocument.files[0] === undefined) {
          this.$message({
            type: 'warning',
            message: 'Seleccione un archivo'
          })
          return
        }
        if (this.nuevoDocumento.hes === '') {
          this.$message({
            type: 'warning',
            message: 'Seleccione una HES'
          })
          return
        }
        this.$confirm('Está por adjuntar y enviar el documento ¿Está seguro?', 'Advertencia', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancelar',
          type: 'warning',
          lockScroll: false
        })
        .then(() => {
          let formData = new FormData()
          formData.append('file', this.$refs.fileDocument.files[0])
          formData.append('folder', 'documents')
          api.request('POST', 'api/uploadFile', formData)
          .then(response => {
            api.request('POST', 'api/generic/buyOrderDocument', JSON.stringify({ 'documentComment': this.nuevoDocumento.documentComment, 'visto': 0, 'lyrics': this.nuevoDocumento.letra, 'expirationDate': this.nuevoDocumento.fechaVencimiento, 'total': this.nuevoDocumento.importeTotal, 'totalTax': this.nuevoDocumento.importeImpuesto, 'currency': this.nuevoDocumento.moneda, 'exchange': this.nuevoDocumento.tipoCambio, 'documentType': this.nuevoDocumento.documentType, 'idBuyOrder': this.buyOrder.idBuyOrder, 'pdf': response.data, 'idBuyOrderDocumentStatus': 1 }))
            .then(buyOrderDocument => {
              api.request('POST', 'api/generic/buyOrderHistory', JSON.stringify({ 'idBuyOrder': this.buyOrder.idBuyOrder, 'detalle': this.$store.state.countStatus[2].description, 'date': this.datetime() }))
              .then(response4 => {
                api.request('GET', 'api/sendMailBuyOrderDocumentStatus/' + buyOrderDocument.data.idBuyOrderDocument)
                if (this.nuevoDocumento.hes) {
                  api.request('POST', 'api/associateHesWithDocument', JSON.stringify({ 'idBuyOrderDocument': buyOrderDocument.data.idBuyOrderDocument, 'hes': this.nuevoDocumento.hes }))
                  .then(response5 => {
                    this.getBuyOrder()
                    this.hideModal()
                  })
                } else {
                  this.getBuyOrder()
                  this.hideModal()
                }
              })
            })
          })
        })
        .catch(() => {
        })
      },
      handleIncluirDocumento (row, idBuyOrderDocumentStatus) {
        if (idBuyOrderDocumentStatus === 2) {
          if (!this.documentosAceptados.includes(row)) {
            this.documentosRechazados = this.documentosRechazados.filter(el => el !== row)
            this.documentosAceptados.push(row)
          } else {
            this.documentosAceptados = this.documentosAceptados.filter(el => el !== row)
          }
        }
        if (idBuyOrderDocumentStatus === 3) {
          if (!this.documentosRechazados.includes(row)) {
            this.documentosAceptados = this.documentosAceptados.filter(el => el !== row)
            this.documentosRechazados.push(row)
          } else {
            this.documentosRechazados = this.documentosRechazados.filter(el => el !== row)
          }
        }
      },
      cerrarModalConfirmarDocumentacion () {
        this.showModalConfirmarDocumentacion = false
        this.documentosRechazados.forEach(el => {
          el.mensajeRechazo = ''
        })
      },
      abrirModalConfirmacion () {
        this.showModalConfirmarDocumentacion = true
      },
      confirmarDocumentos () {
        var cantidadMensajesRechazados = this.documentosRechazados.filter(document => document['mensajeRechazo'] === null || document['mensajeRechazo'] === '').length
        var mensajeAlert = 'Debe completar los campos "Mensaje"'
        if (cantidadMensajesRechazados === 0) {
          this.cambiarEstadoDocumentos(this.documentosRechazados, 3)
          this.cambiarEstadoDocumentos(this.documentosAceptados, 2)
          this.documentosAceptados = []
          this.documentosRechazados = []
          this.cerrarModalConfirmarDocumentacion()
        } else {
          if (cantidadMensajesRechazados === 1) {
            mensajeAlert = 'Debe completar el campo "Mensaje"'
          }
          this.$message({
            type: 'warning',
            message: mensajeAlert
          })
        }
      },
      cambiarEstadoDocumentos (documentos, idBuyOrderDocumentStatus) {
        documentos.forEach(doc => {
          this.cambiarEstadoDocumento(doc, idBuyOrderDocumentStatus)
        })
      },
      cambiarEstadoDocumento (documento, estado) {
        documento.idBuyOrderDocumentStatus = estado.toString()
        api.request('POST', 'api/generic/buyOrderDocument/' + documento.idBuyOrderDocument, JSON.stringify(documento))
        .then(response => {
          if (estado === 3) {
            api.request('GET', 'api/sendMailBuyOrderDocumentStatus/' + documento.idBuyOrderDocument)
          }
        })
      },
      clavarVisto () {
        if (this.user.isProvider) {
          if (this.buyOrder.view === '0' && (this.buyOrder.statusId === '2' || this.buyOrder.statusId === '3' || this.buyOrder.statusId === '6' || this.buyOrder.statusId === '8')) {
            this.buyOrder.view = 1
            api.request('POST', 'api/generic/buyOrder/' + this.buyOrder.idBuyOrder, JSON.stringify(this.buyOrder))
            .then(response => {
              this.getBuyOrder()
            })
          }
          /* if (this.buyOrder.payment && this.buyOrder.payment.visto === '0') {
            this.buyOrder.payment.visto = 1
            api.request('POST', 'api/generic/payment/' + this.buyOrder.payment.idPayment, JSON.stringify(this.buyOrder.payment))
            .then(response => {
              this.getBuyOrder()
            })
          } */
        } else {
          if (this.buyOrder && this.buyOrder.view === '0' && (this.buyOrder.statusId === '9')) {
            this.buyOrder.view = 1
            api.request('POST', 'api/generic/buyOrder/' + this.buyOrder.idBuyOrder, JSON.stringify(this.buyOrder))
            .then(response => {
              this.getBuyOrder()
            })
          }
        }
      },
      activarBuyOrder () {
        this.$confirm('¿Realmente desea activar la OC?', 'Advertencia', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancelar',
          type: 'warning',
          lockScroll: false
        })
        .then(() => {
          this.changeBuyOrderStatus('2')
          api.request('POST', 'api/generic/buyOrderHistory', JSON.stringify({ 'idBuyOrder': this.buyOrder.idBuyOrder, 'detalle': this.$store.state.countStatus[2].description, 'date': this.datetime() }))
              .then(() => {
                this.$parent.getBuyOrders()
              })
        })
        .catch(() => {
        })
      },
      rechazarBuyOrder () {
        this.$confirm('¿Realmente desea rechazar la OC?', 'Advertencia', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancelar',
          type: 'warning',
          lockScroll: false
        })
        .then(() => {
          this.changeBuyOrderStatus('7')
        })
        .catch(() => {
        })
      },
      changeBuyOrderStatus (statusId) {
        return new Promise((resolve, reject) => {
          this.buyOrder.statusId = statusId
          this.buyOrder.view = 0
          api.request('POST', 'api/generic/buyOrder/' + this.buyOrder.idBuyOrder, JSON.stringify(this.buyOrder))
            .then(response => {
              this.getBuyOrder()
              if (response.data.statusId === '2' || response.data.statusId === '9' || response.data.statusId === '8' || response.data.statusId === '6') {
                api.request('GET', 'api/SendMailBuyOrderStatus/' + this.buyOrder.idBuyOrder)
              }
              resolve(response)
            })
        })
      },
      getTypeName (id) {
        let type = this.buyOrderDocumentType.find(el => parseInt(el.idBuyOrderDocumentType) === parseInt(id))
        if (type) {
          return type.description
        } else {
          return ''
        }
      },
      getStatusName (idBuyOrderDocumentStatus) {
        return this.buyOrderDocumentStatus.find(el => el.idBuyOrderDocumentStatus === idBuyOrderDocumentStatus.toString()).description
      },
      getBuyOrderStatusName (id) {
        console.log('--> ' + JSON.stringify(this.statusList))
        if (!this.statusList.length) return '-'
        return this.statusList.find(el => el.statusId === id).description
      },
      toggleLoading () {
        this.loading = (this.loading === '') ? 'cargando' : ''
      },
      resetResponse () {
        this.response = ''
      },
      resetNuevoDocumento () {
        this.nuevoDocumento = {
          idBuyOrder: '',
          importeTotal: 0,
          importeImpuesto: 0,
          importePorcentaje: '',
          moneda: '',
          importeOtrosImpuesto: 0,
          importeTotalImpuesto: 0,
          pdf: '',
          date: '',
          documentType: '',
          visto: 0,
          idBuyOrderDocumentStatus: 1,
          mensajeRechazo: '',
          hes: [],
          lineas: [],
          impuestos: [],
          migo: []
        }
      },
      resetNewPaymentOrder () {
        this.newPaymentOrder = {
          pdf: '',
          comment: ''
        }
        this.buyOrderDocument = ''
      },
      hideModalPaymentOrder () {
        this.showModalPaymentOrder = false
        this.resetNewPaymentOrder()
      }
    },
    mounted () {
      this.clavarVisto()
    },
    beforeMount () {
      this.getBuyOrder()
    }
  }
</script>

<style>
  .datetime-picker input {
    height: 4em !important;
  }
  .statusBtn {
    cursor: context-menu;
  }
  .el-upload.el-upload--text .el-upload__input {
    display:none;
  }
</style>



// WEBPACK FOOTER //
// InvoiceDetail.vue?419d0861